import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { MemberNewsStore } from '../../../common-page-components/stores/entities-store/member-news-store';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class MembersRouterInterceptorService {
    constructor(http) {
        this.http = http;
        /**
         * The members news store to be loaded depen
         *
         * @memberof MembersRouterInterceptorService
         */
        this.memberNewsStore = new MemberNewsStore(this.http);
        /**
         * Subject for check if the url data is continental or not.
         *
         * @memberof MembersRouterInterceptorService
         */
        this.isContinental = new BehaviorSubject(undefined);
    }
    /**
     * Async method for check if the requested data is continental.
     *
     * @readonly
     * @memberof MembersRouterInterceptorService
     */
    get isContinentalMember() {
        return this.isContinental.asObservable().pipe(filter(a => a !== undefined));
    }
}
MembersRouterInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MembersRouterInterceptorService_Factory() { return new MembersRouterInterceptorService(i0.ɵɵinject(i1.HttpClient)); }, token: MembersRouterInterceptorService, providedIn: "root" });
